import React from "react";
import { Link } from "react-router-dom";

const ViewPurchaseBillLayer = ({ bill }) => {
  const items = bill?.PurchaseBillItems || [];
  const expenses = bill?.PurchaseBillExpenses || [];

  const totalItems = items.reduce((sum, i) => sum + Number(i.amount || 0), 0);
  const totalExpenses = expenses.reduce((sum, e) => sum + Number(e.expense_amount || 0), 0);
  const grandTotal = totalItems + totalExpenses;

  return (
    <>
      {/* 🔥 PRINT CSS TO REMOVE HEADER + FOOTER + URL */}
      <style>
        {`
        @media print {
          @page {
            margin: 0;
          }
          html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
          }

          /* HIDE BROWSER HEADER/FOOTER URL */
          a[href]:after {
            content: "" !important;
          }

          /* HIDE WEBSITE HEADER / SIDEBAR / FOOTER */
          nav, header, footer, .navbar, .sidebar, .app-header, .app-footer, .page-header {
            display: none !important;
            visibility: hidden !important;
          }

          /* HIDE PRINT/BTN */
          .no-print, .btn, button {
            display: none !important;
          }

          .card {
            border: none !important;
            box-shadow: none !important;
          }
        }
        `}
      </style>

      <div className="card h-100 p-0 radius-12 print-area">

        {/* HEADER */}
        <div className="card-header d-flex justify-content-between align-items-center no-print">
          <h5 className="mb-0">Purchase Bill Details</h5>

          <div className="d-flex gap-2">
            <button onClick={() => window.print()} className="btn btn-primary no-print">
              Print
            </button>

            <Link to="/list-bills" className="btn btn-secondary no-print">
              Back
            </Link>
          </div>
        </div>

        <div className="card-body p-24">

          {/* Bill Info */}
          <div className="row mb-4">
            <div className="col-md-6">
              <h6 className="fw-semibold text-primary">Bill Info</h6>
              <p><strong>Bill Number:</strong> {bill.bill_number}</p>
              <p><strong>Date:</strong> {new Date(bill.date).toLocaleDateString()}</p>
              <p>
                <strong>Status:</strong>{" "}
                <span
                  className={`badge bg-${
                    bill.status === "Paid"
                      ? "success"
                      : bill.status === "Partially Paid"
                      ? "warning"
                      : "danger"
                  }`}
                >
                  {bill.status}
                </span>
              </p>
            </div>

            <div className="col-md-6">
              <h6 className="fw-semibold text-primary">Supplier Info</h6>
              <p><strong>Name:</strong> {bill.Supplier?.name || "N/A"}</p>
              <p><strong>Email:</strong> {bill.Supplier?.email || "N/A"}</p>
              <p><strong>Phone:</strong> {bill.Supplier?.phone || "N/A"}</p>
            </div>
          </div>

          {/* Items Table */}
          <h6 className="fw-semibold text-primary mb-2">Bill Items</h6>
          <div className="table-responsive mb-4">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {items.length > 0 ? (
                  items.map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.item_name}</td>
                      <td>{item.quantity}</td>
                      <td>{item.rate}</td>
                      <td>Rs. {Number(item.amount).toLocaleString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center text-muted">No items found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Expenses */}
          <h6 className="fw-semibold text-primary mb-2">Additional Expenses</h6>
          <div className="table-responsive mb-4">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Expense Name</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {expenses.length > 0 ? (
                  expenses.map((exp, idx) => (
                    <tr key={idx}>
                      <td>{exp.expense_name}</td>
                      <td>Rs. {Number(exp.expense_amount).toLocaleString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center text-muted">No expenses added</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Summary */}
          <div className="row justify-content-end">
            <div className="col-md-4">
              <table className="table table-sm">
                <tbody>
                  <tr>
                    <td><strong>Items Total:</strong></td>
                    <td className="text-end">Rs. {totalItems.toLocaleString()}</td>
                  </tr>
                  <tr>
                    <td><strong>Expenses Total:</strong></td>
                    <td className="text-end">Rs. {totalExpenses.toLocaleString()}</td>
                  </tr>
                  <tr>
                    <td><strong>Grand Total:</strong></td>
                    <td className="text-end fw-bold">Rs. {grandTotal.toLocaleString()}</td>
                  </tr>
                  <tr>
                    <td><strong>Paid:</strong></td>
                    <td className="text-end">Rs. {bill.paid_amount?.toLocaleString() || 0}</td>
                  </tr>
                  <tr>
                    <td><strong>Due:</strong></td>
                    <td className="text-end text-danger">Rs. {bill.due_amount?.toLocaleString() || 0}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Remarks */}
          {bill.remarks && (
            <div className="mt-3">
              <h6 className="fw-semibold text-primary mb-2">Remarks</h6>
              <p className="border p-2 rounded bg-light">{bill.remarks}</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewPurchaseBillLayer;
